

















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Action, Getter } from 'vuex-class';
import { routes, getTitleFromRouteName } from '@/router';
import { Prop, Watch } from 'vue-property-decorator';
import { IUser } from '@/models';
import Logo from '@/components/UI/Logo.vue';
import { getValue, setValue } from '../../utils';
import { PREFERENCES } from '../../const';
import { getDarkMode } from '@/plugins/dark';
@Component({
  components: {
    Logo,
  },
})
export default class Header extends Vue {
  @Action('logout', { namespace: 'user' }) logout: () => void;
  dark = getDarkMode();

  @Getter('notifications', { namespace: 'user' }) notifications: object[];
  get routeName() {
    const path = this.$route.path || '';
    return getTitleFromRouteName(this.$route.name || '');
  }
  @Watch('dark')
  onDarkChange(value: boolean) {
    this.$vuetify.theme.dark = value;
    setValue(PREFERENCES.PREFER_DARK_MODE, value);
  }
}
